<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

type Props = {
  title: string;
  data?: any;
  checklistName?: string;
};
type Emits = {
  (event: "onChangeInput", name: any, value: any, propertyName?: string): void;
};

defineEmits<Emits>();

defineProps<Props>();
</script>

<template>
  <div class="mb-[40px]">
    <h3
      class="text-primary-text-color text-xl leading-[32px] pb-1 font-semibold tracking-[0.01rem]"
    >
      {{ title }}
    </h3>
    <div v-for="item in data" :key="item.id" class="flex items-center gap-2">
      <label>
        <div
          class="w-full flex items-center gap-2 p-2 pl-1 rounded-primary-radius text-base text-primary-text-color font-normal tracking-[0.01rem] cursor-pointer"
        >
          <div>
            <input
              type="checkbox"
              :name="item.id"
              :checked="item.value"
              :class="item.value ? 'hidden' : 'block'"
              @change="(event:any)=> $emit('onChangeInput',item.id,event.target.checked, checklistName)"
            />
            <img
              v-show="item.value"
              src="@/assets/checkbox-checked.svg"
              alt=""
            />
          </div>
          <span>{{ item.text }}</span>
        </div>
      </label>
    </div>
  </div>
</template>
